import React, { ChangeEvent } from "react";
import { CommentDetail } from "../../../entities/formTemplateDataType";
import { Chevrondown } from "../../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-chevron-down.svg";
import { TemplateStatus } from "../../../entities/Constants";
import { getEnvVar } from "../../../config/RuntimeConfig";

const CMACommentHeaderComponent = ({
    cmaRole,
    comment,
    index,
    isCommentOwner,
    // handleComentChange,
    deleteComment,
    status,
    readOnly,
}: {
    cmaRole: 'A' | 'C',
    comment: CommentDetail,
    index: number,
    isCommentOwner: boolean,
    status?: string,
    // handleComentChange: (e: ChangeEvent<HTMLInputElement>, value: string, index: number) => void,
    deleteComment: (index: number) => void,
    readOnly: boolean,
}) => {
    const publicUrl = getEnvVar('PUBLIC_URL');
    const url = publicUrl === '/' ? '' : `${publicUrl?.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl}/public`;

    let canDelete = false;

    if (status === TemplateStatus.REVISION) {
        canDelete = cmaRole === 'C' && comment.role === 'C' && isCommentOwner;
    }
    if (status === TemplateStatus.APPROVAL_PENDING) {
        canDelete = cmaRole === 'A' && comment.role === 'A' && isCommentOwner;
    }
    if (readOnly) {
        canDelete = false;
    }
    return (
        <div className='comment-header'>
            <div className="comment-title-sectioin">
                <div className="comment-owner">
                    <p style={{ marginBottom: '0' }}><b>{comment.MadeBy ?? ''}{comment.role == 'A' ? ' (Approver)' : ''}</b></p>
                    <span>{comment.MadeOn ?? ''}</span>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }} key={`Checkbox_${comment.id ?? ''}_${index}`} title={comment.Comments}>
                {canDelete && (
                    <button
                        className="message_button"
                        // style={{ backgroundColor: "#f2f2f2", border: "none" }}
                        style={{ background: comment.role == 'C' ? '#f2f0f4' : '#e2f0f4', border: "none" }}
                        onClick={() => deleteComment(index)}
                    >
                        <img src={`${url}/assets/css/ontario-design-system/icons/svg/ontario-icon-delete.svg`} />
                    </button>
                )}
                <button className="message_button" style={{ background: `${comment.role == 'C' ? '#f2f2f2' : '#e2f0f4'}`, border: 'none' }}>
                    {/* <Chevrondown /> */}
                    <img src={`${url}/assets/css/ontario-design-system/icons/svg/ontario-icon-chevron-down.svg`} alt="Chevron Down" />
                </button>
            </div>
        </div>
    );
}

export default CMACommentHeaderComponent;